"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerationSerializeService = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
class GenerationSerializeService {
    static deserializeGenerationSettings(settings) {
        const mediafiles = settings.mediafiles.map((mf) => this.deserializeMediafile(mf));
        return {
            numberMediafiles: settings.number_mediafiles,
            mediafiles,
            stream: this.deserializeStream(settings.stream),
            rotatedMediafiles: settings.rotated_mediafiles,
            onetooneSeparate: settings.one_to_one_separate,
            dislikedMediafiles: settings.disliked_mediafiles,
            silentMediafile: this.deserializeMediafile(settings.silent_mediafile),
            mediafileBlocks: settings.mediafile_blocks,
            allBlocks: settings.all_blocks.map((bl) => this.deserializeBlock(bl)),
            jingleGroups: [],
            timezone: settings.timezone,
            crossfade: settings.crossfade,
            lastRotations: [],
            startTime: (0, moment_timezone_1.default)(settings.start_time),
            adcampaigns: settings.adcampaigns.map((adCompaign) => this.deserializeAdCampaign(adCompaign)),
            availableMediafileIds: [],
            generationType: "correction",
            pattern: settings.with_music_cut ? "with_music_cut" : "without_music_cut",
            cutDuration: settings.cut_duration || 0,
        };
    }
    static deserializeGenerationMediafile(mediafile) {
        return Object.assign(Object.assign({}, mediafile), { files: [
                {
                    filename: mediafile.filename,
                    cacheState: 0,
                    size: mediafile.size,
                    duration: mediafile.duration,
                    crcHash: mediafile.crcHash,
                },
            ], duration: mediafile.duration / 1000, cacheState: 0, lastPlaytime: Date.now(), meta: {
                type: mediafile.type,
                cueIn: mediafile.cueIn,
                cueOut: mediafile.cueOut,
                fadeIn: mediafile.fadeIn,
                fadeOut: mediafile.fadeOut,
                startNext: mediafile.startNext,
                size: mediafile.size,
                duration: mediafile.duration,
            } });
    }
    static deserializeMediafile(mediafile) {
        return {
            aggregateValues: mediafile.aggregate_values,
            performerTitle: mediafile.performer_title,
            crossfadeDuration: mediafile.crossfade_duration,
            marksJson: mediafile.marks_json,
            id: mediafile.id,
            type: mediafile.type,
            bpm: mediafile.bpm,
            rms: mediafile.rms,
            duration: mediafile.duration,
        };
    }
    static deserializeStream(stream) {
        return Object.assign(Object.assign({}, stream), { blockPattern: stream.block_pattern });
    }
    static deserializeBlock(block) {
        return {
            endDate: block.end_date ? (0, moment_timezone_1.default)(block.end_date) : undefined,
            startDate: block.start_date ? (0, moment_timezone_1.default)(block.start_date) : undefined,
            endDayTime: block.end_day_time ? this.deserializeTimeString(block.end_day_time) : undefined,
            startDayTime: block.start_day_time
                ? this.deserializeTimeString(block.start_day_time)
                : undefined,
            isSpecial: block.is_special,
            id: block.id,
            days: block.days,
            rules: block.rules,
            pattern: block.pattern,
        };
    }
    static deserializeAdCampaign(ad) {
        var _a;
        const promos = ad.promos.map((mediafile) => this.deserializeMediafile(mediafile));
        const promoads = ad.promoad.map((promo) => this.deserializePromoAd(promo));
        return {
            prevMediafileRequired: ad.prev_mediafile_required,
            oneDay: ad.one_day,
            sortedValueIds: ad.sorted_value_ids,
            endDayTime: ad.end_day_time ? this.deserializeTimeString(ad.end_day_time) : undefined,
            startDayTime: ad.start_day_time ? this.deserializeTimeString(ad.start_day_time) : undefined,
            endCompany: ad.end_company ? (0, moment_timezone_1.default)(ad.end_company) : undefined,
            startCompany: ad.start_company ? (0, moment_timezone_1.default)(ad.start_company) : undefined,
            sortedValueMediafiles: (_a = ad.sorted_value_mediafiles) !== null && _a !== void 0 ? _a : undefined,
            id: ad.id,
            days: ad.days,
            type: ad.type,
            infinitely: ad.infinitely,
            interval: ad.interval,
            period: ad.period,
            promos: [...promos],
            promoad: [...promoads],
        };
    }
    static deserializeTimeString(time) {
        const [h, m, _] = time.split(":").map((num) => Number(num));
        return { h, m };
    }
    static deserializePromoAd(promo) {
        return {
            promoId: promo.promo_id,
            id: promo.id,
            time: this.deserializeTimeString(promo.time),
            order: promo.order,
        };
    }
}
exports.GenerationSerializeService = GenerationSerializeService;
//# sourceMappingURL=generation-serialize.service.js.map